<template>
  <div id="upload-data" class="m-t-10">
    <form @submit.prevent="submitForm">
      <div class="form-group">
        <label for="jenis-data">Jenis Data</label>
        <select id="jenis-data" class="form-control rounded" v-model="tipe">
          <option value="" disabled selected>Pilih Jenis Data</option>
          <option value="medsos">Media Sosial</option>
          <option value="medkon">Media Konvensional</option>
        </select>
      </div>
      <span style="font-size: 14px">File</span>
      <div class="input-group">
        <div class="custom-file">
          <input
            type="file"
            ref="fileInput"
            class="custom-file-input"
            placeholder="Pilih File"
            id="input-file"
            aria-describedby="fileInput"
            @change="getData"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          />
          <label class="custom-file-label" for="input-file">
            {{ file_input != null ? file_input.name : "Pilih File" }}
          </label>
        </div>
      </div>
      <div class="form-group mt-3">
        <label for="IDTask">ID Task SiIteung</label>
        <input
          id="IDTask"
          type="text"
          v-model="id_task"
          class="form-control rounded"
          placeholder="Masukkan ID Task"
        />
      </div>
      <div class="form-group">
        <label for="tanggal">Periode Data</label> <br />
        <date-picker
          v-model="periode"
          valueType="format"
          type="datetime"
          range
          class="w-100"
        ></date-picker>
      </div>
      <div class="form-group mt-5" align="right">
        <button
          type="button"
          id="close-modal"
          class="btn btn-danger m-r-5"
          data-dismiss="modal"
        >
          Batal
        </button>
        <button
          type="submit"
          class="btn btn-primary"
          :disabled="
            !tipe || !file_input || periode[0] == null || periode[1] == null
          "
        >
          <span>Preview</span>
        </button>
      </div>
    </form>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";

export default {
  nama: "modal_upload_data",
  components: {
    DatePicker,
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      tipe: this.data.tipe,
      file_input: this.data.file_input,
      id_task: this.data.id_task,
      periode: [this.data.periode.start || null, this.data.periode.end || null],
    };
  },
  methods: {
    getData: function(f) {
      let file = f.target.files[0];
      this.file_input = file;
    },
    submitForm: function() {
      const periode_seleted = {
        start: moment(this.periode[0]).format("YYYY-MM-DD HH:mm:ss"),
        end: moment(this.periode[1]).format("YYYY-MM-DD HH:mm:ss"),
      };
      this.$parent.$parent.setDataFromModal(
        this.tipe,
        this.file_input,
        this.id_task,
        periode_seleted
      );
      var closeButton = document.getElementById("close-modal");
      if (closeButton) {
        closeButton.click();
      }
    },
  },
};
</script>
